(function (root, factory) {
  var api = factory(root);

  root.PjDesignLabDigitalUpsell = api;

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
})(typeof window !== 'undefined' ? window : globalThis, function (root) {
  'use strict';

  var CONFIG_ID = 'pjDesignLabDigitalConfig';
  var CARD_SELECTOR = '[data-pj-digital-card]';
  var TOGGLE_SELECTOR = '[data-pj-digital-toggle]';
  var INPUT_SELECTOR = '.extraOption[data-identifier="digital-artwork"]';
  var BUYBOX_SELECTORS = ['#surge-combined-listing-shell', '.main-product-section'];

  function query(doc, selector) {
    return doc && typeof doc.querySelector === 'function' ? doc.querySelector(selector) : null;
  }

  function parseConfig(doc) {
    var node = doc && typeof doc.getElementById === 'function' ? doc.getElementById(CONFIG_ID) : null;
    if (!node || !node.textContent) return null;

    try {
      var config = JSON.parse(node.textContent);
      return config && config.variantId ? config : null;
    } catch (error) {
      return null;
    }
  }

  function findCard(doc) {
    return query(doc, CARD_SELECTOR);
  }

  function findToggle(doc) {
    return query(doc, TOGGLE_SELECTOR);
  }

  function findInput(doc) {
    return query(doc, INPUT_SELECTOR);
  }

  function buyBoxRoot(doc) {
    for (var i = 0; i < BUYBOX_SELECTORS.length; i += 1) {
      var root = query(doc, BUYBOX_SELECTORS[i]);
      if (root) return root;
    }
    return null;
  }

  function priceLabel(config) {
    if (config.priceLabel) return config.priceLabel;
    return '$' + Number(config.price || 0).toFixed(2);
  }

  function paintCard(doc, config) {
    var card = findCard(doc);
    if (!card) return false;

    var label = query(doc, '#pvDigitalLabel');
    var description = query(doc, '#pvDigitalDesc');
    var icon = query(doc, '#pvDigitalIco');

    if (label) label.textContent = (config.label || 'Add the digital artwork') + ' — ' + priceLabel(config);
    if (description) description.textContent = config.description || '';
    if (config.icon && icon && typeof icon.innerHTML === 'string') {
      icon.innerHTML = '<img src="' + config.icon + '" alt="" width="20" height="20" loading="lazy">';
    }

    card.hidden = false;
    return true;
  }

  // The add-to-cart collects add-ons from the buy box, and a combined-listing
  // swap rebuilds that DOM - so the input is (re)created here rather than
  // rendered once, and the card, which lives in the body-level modal and
  // survives the swap, stays the source of truth for whether it is ticked.
  function mountInput(doc, config) {
    var existing = findInput(doc);
    if (existing) return existing;

    var host = buyBoxRoot(doc);
    if (!host || typeof doc.createElement !== 'function') return null;

    var input = doc.createElement('input');
    input.type = 'checkbox';
    input.className = 'extraOption extraOption_digital-artwork visually-hidden';
    input.id = 'pjDigitalArtworkOption';
    input.name = 'extra_options';
    input.value = String(config.variantId);
    input.setAttribute('data-identifier', 'digital-artwork');
    input.setAttribute('data-pj-digital-price', String(config.price || 0));
    input.setAttribute('aria-label', (config.label || 'Add the digital artwork') + ' ' + priceLabel(config));

    if (typeof host.appendChild === 'function') host.appendChild(input);

    return input;
  }

  function isChecked(doc) {
    var toggle = findToggle(doc);
    return Boolean(toggle && toggle.checked);
  }

  function notifyChange(input) {
    if (!input || typeof input.dispatchEvent !== 'function') return;
    if (typeof root.Event !== 'function') return;
    input.dispatchEvent(new root.Event('change', { bubbles: true }));
  }

  function updateTotal() {
    if (typeof root.updateButtonTotal === 'function') root.updateButtonTotal();
  }

  function sync(doc, config) {
    var input = config ? mountInput(doc, config) : findInput(doc);
    if (!input) return false;

    input.checked = isChecked(doc);
    notifyChange(input);
    updateTotal();

    return input.checked;
  }

  function setChecked(doc, checked, config) {
    var toggle = findToggle(doc);
    if (toggle) toggle.checked = Boolean(checked);
    return sync(doc, config);
  }

  function createController(doc) {
    var config = null;
    var bound = false;

    function onToggleChange() {
      sync(doc, config);
    }

    function onCartUpdated() {
      setChecked(doc, false, config);
    }

    function onShellReplaced() {
      sync(doc, config);
    }

    function init() {
      if (bound) return false;

      config = parseConfig(doc);
      if (!config) return false;

      var toggle = findToggle(doc);
      if (!toggle || !paintCard(doc, config)) return false;

      if (typeof toggle.addEventListener === 'function') {
        toggle.addEventListener('change', onToggleChange);
      }
      if (doc && typeof doc.addEventListener === 'function') {
        doc.addEventListener('cart:updated', onCartUpdated);
        doc.addEventListener('surge:combined-listing-shell-replaced', onShellReplaced);
        doc.addEventListener('variant:change', onShellReplaced);
      }

      bound = true;
      sync(doc, config);
      return true;
    }

    return {
      config: function () {
        return config;
      },
      init: init,
      isChecked: function () {
        return isChecked(doc);
      },
      restore: function () {
        return sync(doc, config);
      },
      setChecked: function (checked) {
        return setChecked(doc, checked, config);
      },
      sync: function () {
        return sync(doc, config);
      },
    };
  }

  var controller = null;

  if (typeof root.document !== 'undefined' && root.document) {
    controller = createController(root.document);

    if (root.document.readyState === 'loading') {
      root.document.addEventListener('DOMContentLoaded', controller.init);
    } else {
      controller.init();
    }
  }

  return {
    createController: createController,
    findCard: findCard,
    findInput: findInput,
    findToggle: findToggle,
    init: controller && controller.init,
    isChecked: isChecked,
    parseConfig: parseConfig,
  };
});
